// eslint-disable-next-line import/prefer-default-export
export const BxSplitCell = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.934 2.59888H20.184H12.3569H12.2718H3.81592H3.06592V3.34888V20.6511V21.4011H3.81592H12.2718H12.3569H20.184H20.934V20.6511V3.34888V2.59888ZM11.25 19.9011H4.56592V12.5312L6.34505 14.4123L6.75734 14.8482L7.62916 14.0236L7.21687 13.5877L6.28267 12.6H9.14551H9.74551V11.4H9.14551H6.28267L7.21687 10.4123L7.62916 9.97638L6.75734 9.1518L6.34505 9.58771L4.56592 11.4688V4.09888H11.2502L11.2501 5.00079L12.7501 5.0008L12.7502 4.09888H19.434V11.4905L17.6325 9.58751L17.22 9.15179L16.3485 9.97676L16.761 10.4125L17.6959 11.4H14.8301H14.2301V12.6H14.8301H17.6959L16.761 13.5875L16.3485 14.0232L17.22 14.8482L17.6325 14.4125L19.434 12.5095V19.9011H12.75L12.75 19.0085L11.25 19.0085L11.25 19.9011ZM11.2501 9.00299L11.2501 7.00189L12.7501 7.0019L12.7501 9.003L11.2501 9.00299ZM11.2501 13.0052L11.2501 11.0041L12.7501 11.0041L12.7501 13.0052L11.2501 13.0052ZM11.2501 17.0074L11.2501 15.0063L12.7501 15.0063L12.7501 17.0074L11.2501 17.0074Z"
      fill="#2C2E34"
    />
  </svg>
)
